import Vue from 'vue';
import Vuex from 'vuex';
import Auth from './Auth';
import Components from "./Components";
import Formatter from "./Formatter";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    Auth,
    Components,
    Formatter
  },
});
